import { useQuery } from "react-query";
import queryString from "query-string";
import http from "infra/http";
import URL from "core/resources/urls";
import type { PrevisaoEstoqueApiItem } from "../consultarEstoque/types";
import { normalizePrevisaoEstoqueResponse } from "../consultarEstoque/normalizePrevisaoEstoque";

function useGetPrevisaoEstoque(
  fazendaId: string | undefined,
  insumoIds: string[],
  ordemServicoId?: string,
) {
  const insumoIdsKey = Array.from(new Set(insumoIds.filter(Boolean))).sort();

  return useQuery(
    [URL.ORDEM_SERVICO.PREVISAO_ESTOQUE, fazendaId, insumoIdsKey, ordemServicoId],
    async (): Promise<PrevisaoEstoqueApiItem[]> => {
      const { data } = await http.get(URL.ORDEM_SERVICO.PREVISAO_ESTOQUE, {
        params: {
          fazendaId,
          insumoIds: insumoIdsKey,
          ...(ordemServicoId ? { ordemServicoId } : {}),
        },
        paramsSerializer: params =>
          queryString.stringify(params, { arrayFormat: "none" }),
      });

      return normalizePrevisaoEstoqueResponse(data);
    },
    {
      enabled: !!fazendaId && insumoIdsKey.length > 0,
      keepPreviousData: true,
    },
  );
}

export default useGetPrevisaoEstoque;
